import React from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default function CircularIcon(props) {
  return (
    <div className="CircularIcon">
      <span className="material-icons">{props.icon}</span>
    </div>
  )
}

CircularIcon.propTypes = {
  icon: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/CircularIcon/index.js